import { NgModule, InjectionToken } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule, ActionReducerMap } from '@ngrx/store';
import { statsigReducer, statsigExperimentsKey } from '@statsig/store/statsig.reducers';

import { StoreState } from '@statsig/statsig.entities';
import { StatsigExperimentsService } from '@statsig/services/statsig.service';
import { StatsigExperimentsFacade } from '@statsig/statsig.facade';


export const FEATURE_REDUCER_TOKEN = new InjectionToken<
  ActionReducerMap<StoreState>
>('Feature Reducers');

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(statsigExperimentsKey, FEATURE_REDUCER_TOKEN)
  ],
  providers: [
    {
      provide: FEATURE_REDUCER_TOKEN,
      useValue: statsigReducer,
    },
    StatsigExperimentsFacade,
    StatsigExperimentsService,
  ]
})
export class StatsigModule { }
